import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ButtonHelpService} from "fuse-core/components/button-help/button-help.service";
import {Observable, of} from 'rxjs';

@Component({
    selector: 'app-button-help',
    templateUrl: './button-help.component.html',
    standalone: false
})
export class ButtonHelpComponent implements OnInit {
    @Input() public isMobileLayout$?: Observable<boolean> = of(false); // Default to false when parent doesn't provide a value

    constructor(
        private router: Router,
        private buttonHelpService: ButtonHelpService,
    ) {}

    ngOnInit(): void {}

    public openHelpContent(): void {
        this.buttonHelpService.openCurrentHelpPage();
    }

    public isDisplay(): boolean {
        return this.buttonHelpService.hasHelpPage();
    }
}
